import React, { useEffect, useState } from "react";
import { AsyncCallArgs, CardSpg, ErrorAlert, SuccessAlert, useAsyncCall } from "@duosoftbg/nacid-components";
import { userChangeEmail } from "../../../../../axios/api/services";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { CardContent } from "@mui/material";
import { TemporaryKeyStatusType } from "../../../../../constants/temporaryKeyStatusType";

const renderChangeEmailResult = (activationResult) => {
  if (activationResult.status) {
    switch (activationResult.status) {
      case TemporaryKeyStatusType.KEY_NOT_FOUND:
        return <ErrorAlert message={"m.change.email.key.invalid"} />;
      case TemporaryKeyStatusType.NEW_EMAIL_NOT_FOUND:
        return <ErrorAlert message={"m.change.email.new.email.not.found"} />;
      case TemporaryKeyStatusType.USER_NOT_FOUND:
        return <ErrorAlert message={"m.change.email.user.invalid"} />;
      case TemporaryKeyStatusType.USED_KEY:
        return <ErrorAlert message={"m.change.email.used.key"} dynamicValuesObject={activationResult.user} />;
      case TemporaryKeyStatusType.EXPIRED_KEY:
        return <ErrorAlert message={"m.change.email.key.expired"} />;
      case TemporaryKeyStatusType.INVALID_EMAIL:
        return <ErrorAlert message={"m.change.email.new.email.invalid"} />;
      case TemporaryKeyStatusType.EXCEPTION:
        return <ErrorAlert message={"m.change.email.error"} />;
      case TemporaryKeyStatusType.SUCCESS:
        return (
          <SuccessAlert
            message={"m.change.email.success"}
            dynamicValuesObject={{ newEmail: activationResult.newEmail }}
          />
        );
      default:
        return null;
    }
  }
};

const EmailChange = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const [searchParams] = useSearchParams();
  const [activationResult, setActivationResult] = useState({ status: null, user: null });

  useEffect(() => {
    const asyncCallArgs: AsyncCallArgs = {
      promise: userChangeEmail(searchParams.get("key")),
      onSuccess: (response) => {
        setActivationResult(response);
      },
      onError: () => {
        setActivationResult({ status: TemporaryKeyStatusType.EXCEPTION, user: null });
      },
    };
    asyncCall(asyncCallArgs);

    // eslint-disable-next-line
    }, []);

  return (
    <PageWrapper title={t("t.page.change.email")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          {renderChangeEmailResult(activationResult)}
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};

export default EmailChange;
